module.exports = __webpack_public_path__ + "static/media/ice-cream-header.1f373b97.png";